import {
	IsArray,
	IsBoolean,
	IsDateString,
	IsEnum,
	IsNotEmpty,
	IsNumber,
	IsOptional,
	IsString,
	IsUUID,
	Min,
	IsIn,
	IsInt,
} from 'class-validator';
import { MarketStatus } from '../../enums';
import { Type } from 'class-transformer';

export class GetMarketsParamsDto {
	@IsOptional()
	@IsUUID()
	event_id?: string;

	@IsOptional()
	@IsUUID()
	lobby_id?: string;

	@IsOptional()
	@IsString()
	sort?: string;
}

export class GetActiveMarketsParamsDto {
	@IsOptional()
	@IsNumber()
	skip?: number;

	@IsOptional()
	@IsNumber()
	limit?: number;

	@IsOptional()
	@IsString()
	search?: string;

	@IsOptional()
	@IsUUID()
	category_id?: string;
}

//ToDo - add real market dto when merged with JWB-3250
export class ActiveMarketsDto {
	data: {
		markets: any[];
		categoriesIds: string[];
	};
	currentPage: number;
	totalPages: number;
}

export class SettleSecondChanceMarketDto {
	@IsUUID('4')
	@IsNotEmpty()
	marketId: string;

	@IsNumber()
	score: number;
}

export class CreateSecondChanceMarketDto {
	@IsUUID('4')
	@IsNotEmpty()
	lobby_id: string;

	@IsString()
	@IsNotEmpty()
	question: string;

	@IsOptional()
	@IsString()
	context?: string;

	@IsOptional()
	@IsNumber()
	@Min(0)
	priority?: number;

	@IsOptional()
	@IsNumber()
	min_value?: number;

	@IsOptional()
	@IsNumber()
	max_value?: number;

	@IsOptional()
	@IsNumber()
	score?: number;
}

export class UpdateSecondChanceMarketDto {
	@IsUUID('4')
	@IsNotEmpty()
	id: string;

	@IsOptional()
	@IsString()
	question?: string;

	@IsOptional()
	@IsString()
	context?: string;

	@IsOptional()
	@IsNumber()
	@Min(0)
	priority?: number;

	@IsOptional()
	@IsEnum(MarketStatus)
	status?: MarketStatus;

	@IsOptional()
	@IsNumber()
	min_value?: number;

	@IsOptional()
	@IsNumber()
	max_value?: number;

	@IsOptional()
	@IsNumber()
	score?: number;

	@IsOptional()
	@IsDateString()
	closing_date?: string;
}

export class UpdateMarketDto {
	@IsUUID('4')
	@IsNotEmpty()
	id: string;

	@IsOptional()
	@IsString()
	question?: string;

	@IsOptional()
	@IsDateString()
	opening_time?: string | null;

	@IsOptional()
	@IsDateString()
	closing_date?: string | null;

	@IsOptional()
	@IsString()
	context?: string | null;

	@IsOptional()
	@IsEnum(MarketStatus)
	status?: MarketStatus;

	@IsOptional()
	@IsUUID('4')
	match_id?: string | null;

	@IsOptional()
	@IsUUID('4')
	category_id?: string | null;

	@IsOptional()
	@IsDateString()
	updated_date?: string;

	@IsOptional()
	@IsDateString()
	settled_date?: string | null;

	@IsOptional()
	@IsBoolean()
	is_settle_at_end?: boolean;

	@IsOptional()
	@IsArray()
	@IsUUID('4', { each: true })
	lobby_ids?: string[];

	@IsOptional()
	@IsNumber()
	@Min(0)
	priority?: number;
}
export class MarketDto {
	id: string;
	created_by: string;
	event_id: string;
	question: string;
	initial_value: number;
	current_value?: number;
	priority?: number;
	second_chance_priority?: number;
	h2h_priority?: number;
	status?: MarketStatus;
	start_date: Date;
	created_date?: Date;
	opening_time?: Date;
	closing_date?: Date;
	settled_date?: Date;
	trade_start_at?: Date;
	match_id?: string;
	category_id?: string;
	context?: string;
	ext_api_market_id?: string;
	ext_api_market?: string;
	ext_api_name?: string;
	is_settle_at_end?: boolean;
	is_second_chance?: boolean;
	updated_odds_date?: Date;
	stat_threshold?: number;
	stat_current?: number;
}

export enum MarketSortField {
	CreatedDate = 'created_date',
	Priority = 'priority',
	ClosingDate = 'closing_date',
	OpeningTime = 'opening_time',
}

export enum SortDirection {
	Asc = 'asc',
	Desc = 'desc',
}

export const MAX_MARKETS_PAGE_SIZE = 50;

export class GetMarketsListDto {
	@IsUUID()
	eventId: string;

	@IsOptional()
	@IsUUID()
	lobbyId?: string;

	@IsOptional()
	@IsUUID()
	slateId?: string;

	@IsOptional()
	@IsUUID()
	matchId?: string;

	@IsOptional()
	@IsIn([...Object.values(MarketStatus), 'all'])
	status?: MarketStatus | 'all';

	@IsOptional()
	@IsArray()
	@IsString({ each: true })
	marketGroups?: string[];

	@IsOptional()
	@IsEnum(MarketSortField)
	sortBy?: MarketSortField;

	@IsOptional()
	@IsEnum(SortDirection)
	sortDirection?: SortDirection;

	@IsOptional()
	@Type(() => Number)
	@IsInt()
	@Min(1)
	page?: number;

	@IsOptional()
	@Type(() => Number)
	@IsInt()
	@Min(1)
	pageSize?: number;
}
